import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { OrgChartNode } from "../models/org-chart-node";

@Component({
  selector: "app-tree-node",
  templateUrl: "./tree-node.component.html",
  styleUrls: ["./tree-node.component.scss"],
})
export class TreeNodeComponent implements OnInit {
  @Input() treeNode: OrgChartNode;
  @Output() editNode = new EventEmitter<OrgChartNode>();
  collapsed: boolean = false;

  get hasChildren(): boolean {
    return (
      this.treeNode &&
      this.treeNode.employees &&
      this.treeNode.employees.length > 0
    );
  }
  constructor() {}

  ngOnInit() {}
  edit(employee: OrgChartNode) {
    this.editNode.emit(employee);
  }
  toggle() {
    this.collapsed = this.treeNode.collapsed;
    this.treeNode.collapsed = !this.treeNode.collapsed;
    if (this.treeNode.collapsed) {
      this.collapseChildren(this.treeNode);
    }
  }
  private collapseChildren(employee) {
    if (employee.employees) {
      employee.employees.forEach((e) => {
        e.collapsed = true;
        this.collapseChildren(e);
      });
    }
  }
  getAllChildNodes(employee: OrgChartNode[]): number {
    var employeeCount = 0;
    for (var i = 0; i < employee.length; i++) {
      if (employee[i].employees.length > 0) {
        employeeCount += this.getNodeCount(employee[i].employees);
      }
    }
    employeeCount += employee.length;
    return employeeCount;
  }
  getNodeCount(employee: OrgChartNode[]): number {
    var employeeCount = 0;
    for (var i = 0; i < employee.length; i++) {
      if (employee[i].employees.length > 0)
        employeeCount += this.getNodeCount(employee[i].employees);
    }
    employeeCount += employee.length;
    return employeeCount;
  }
}
